/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CostCenterRestService } from '@gh/builder-shared-data';
import { InitViewService, isRouteForCreationMode } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { of$ } from '@gh/rx';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  CostCenterDetails,
  costCenterDetailsFromDto,
  costCenterDetailsToDto,
  newCostCenter,
} from './cost-center-details.model';

@Injectable()
export class CostCenterDetailsBusinessService implements InitViewService {
  constructor(private costCenterRest: CostCenterRestService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    const { costCenterId } = route.params;

    const costCenter$ = isRouteForCreationMode(route) ? of$(newCostCenter()) : this.get(costCenterId);

    return {
      costCenter: costCenter$,
    };
  }

  save(costCenter: CostCenterDetails): Observable<CostCenterDetails> {
    return costCenter.id ? this.update(costCenter) : this.create(costCenter);
  }

  create(costCenter: CostCenterDetails): Observable<CostCenterDetails> {
    return this.costCenterRest.create(costCenterDetailsToDto(costCenter)).pipe(map$(costCenterDetailsFromDto));
  }

  update(costCenter: CostCenterDetails): Observable<CostCenterDetails> {
    return this.costCenterRest.update(costCenterDetailsToDto(costCenter)).pipe(map$(costCenterDetailsFromDto));
  }

  get(id: ID): Observable<CostCenterDetails> {
    return this.costCenterRest.get(id).pipe(map$(costCenterDetailsFromDto));
  }

  propagateCostCenter(costCenterId?: ID): Observable<CostCenterDetails> {
    return this.costCenterRest.propagateCostCenter(costCenterId).pipe(map$(costCenterDetailsFromDto));
  }
  getMatchingCostCenterCodes(searchString: string): Observable<string[]> {
    return this.costCenterRest.getCostCenterCodes(searchString);
  }
}
